module.exports = __webpack_public_path__ + "img/blue.e6fc4819.svg";